import React, { memo } from 'react';
import { BaseImageProps } from './Image.types';

interface ImageProps extends BaseImageProps {
	loading?: React.ImgHTMLAttributes<HTMLImageElement>['loading'];
	onClick?: React.ImgHTMLAttributes<HTMLImageElement>['onClick'];
	onLoad?: React.ImgHTMLAttributes<HTMLImageElement>['onLoad'];
	onError?: React.ImgHTMLAttributes<HTMLImageElement>['onError'];
}

export const Image = memo(({ src, className, loading, onClick, onLoad, onError, description, textOnImage }: ImageProps) => {
	return (
		<img
			src={src}
			className={className}
			alt={[description, textOnImage].filter((x) => x).join(' ')}
			title={textOnImage}
			loading={loading}
			onClick={onClick}
			onLoad={onLoad}
			onError={onError}
		/>
	);
});
